import React from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import Editdepartment from './editdepartment';
import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";


function Departmentlist(props) {
    const [data, setData] = useState([]);
    const accesstoken = localStorage.getItem("token");
    const navigate = useNavigate();

    const Swal = require('sweetalert2')

    // get all department details
    useEffect(() => {
        const GetAllDept = () => {
            axios
                .get(baseurladdress + `findalldept`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then(res => {
                    const datas = res.data.response;
                    console.log("itemss" + datas);
                    //alert(datas);
                    const dept = datas.map((item, index) => (

                        <tr  id={"chk" + item.dept_id}>
                            <td>{index + 1}</td>
                            <td>{item.dept_name}</td>
                            <td>{item.dept_headname}</td>
                            <td>{item.dept_code}</td>
                            <td>{item.dept_description}</td>
                            <td>
                                <div>
                                    {(() => {
                                        if (item.dept_status == 0) {
                                            return (
                                                <div>
                                                    <span class="badge bg-danger" >
                                                        Inactive
                                                    </span>
                                                </div>
                                            );
                                        } else if (item.dept_status == 1) {
                                            return (
                                                <div><span class="badge bg-success">Active</span></div>
                                            )
                                        }
                                    })()}
                                </div></td>
                            <td>
                                <a
                                    class="inline-block"
                                    href="#"
                                >
                                    <i class="text-primary fa fa-edit" onClick={() => Editdepartment(item.dept_id)}></i>
                                </a>
                            </td>
                            <td style={{textAlign: "center"}}>
                                <i class="text-danger fa fa-trash" onClick={() => deletedepartment(item.dept_id)}></i>
                            </td>
                        </tr>
                    ));
                    setData(dept);
                })
                .catch(error => {
                    alert(error);
                })
        }
        GetAllDept();
    }, []);

    //delete department

    function deletedepartment(dept_id) {
        if (
            window.confirm(
                "Are you sure you want to delete this data? This cannot be undo later."
            )
        ) {
            fetch(baseurladdress + `deletedepartment/${dept_id}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }).then((response) => {
                if (response.status === 200) {

                    $("#chk" + dept_id).fadeOut(200, function () { $(this).css('display', 'none'); });
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'success',
                        title: 'Deleted Successfully'
                    })
                    window.location.reload();
                }
            });
        }
    };

    function Deptposting() {
        navigate("/adddepartment");
    }
    function Editdepartment(dept_id) {
        navigate("/editdepartment/" + dept_id);
    }
   
    $(function () {
        setTimeout(function () {
            $('#dept').DataTable();
        }, 1000);
    });
    

    return (
        <div>
            <Topnavbar />
            <Sidennav />
      
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div class="card">
                                <div class="card-header" style={{ "color": "black" }}>
                                    <h6 class="card-title"> DEPARTMENT DETAILS
                                    </h6>
                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn plus-icon d-flex align-items-center"
                                            onClick={() => Deptposting()}
                                            style={{ marginRight: '50px' }}
                                        >
                                            <span style={{ fontSize: "1.2rem" }}><i className='fa fa-plus-circle text-success'></i></span>
                                            <span style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}> Add</span>
                                        </button>
                                    </div>
                                </div>

                                
                                <div class="card-body">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-responsive-sm" id="dept">
                                                        <thead >
                                                            <tr>
                                                                <th>Sl.No</th>
                                                                <th>Department</th>
                                                                <th>Department Head Name</th>
                                                                <th>Department Code</th>
                                                                <th>Description</th>
                                                                <th>Status</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Departmentlist;
